module.exports = __webpack_public_path__ + "static/media/boa-lock-icon.02d46c00.svg";